<ng-template [ngIf]="project?.reporting">
	<div class="text-warning">
		<i class="fa fa-exclamation-triangle"></i>
		{{'labels.project-reporting-warning' | translate}}
	</div>
	<br>
</ng-template>
Inserire il numero di ore presso la sede del cliente (IN) o esternamente (OUT) erogate per ciascuna attività.
<div
	#tablearea
	class="tablearea">

	<div
		class="row"
		*ngIf="loading">
		<div class="icon-loading">
			<span>
				<i class="fa fa-circle-notch fa-spin fa-2x"></i>
			</span>

		</div>
	</div>
	<div class="row">
		<div class="col">

			<a
				class="float-right btn btn-sm btn-primary"
				(click)="add()"
				*ngIf="project?.isDraft">
				<i
					container="body"
					ngbTooltip="{{'labels.add-resource' | translate}}"
					class="feather icon-plus"></i>
			</a>

		</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && !resources?.length">
		<div class="col text-center  p-5">{{'labels.no-resources' | translate}}</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && !objectives?.length">
		<div class="col text-center  p-5">
			{{'labels.no-objectives' | translate}}
			<a
				routerLink="/company/project/view/{{this.projectid}}"
				fragment="obiettivi">
				{{'labels.objective-create' | translate}}
			</a>
		</div>
	</div>

	<div
		class="row"
		*ngIf="!loading && objectives?.length && !activities">
		<div class="col text-center  p-5">
			{{'labels.no-activities' | translate}}
			<a
				routerLink="/company/project/view/{{this.projectid}}"
				fragment="obiettivi">
				{{'labels.activity-create' | translate}}
			</a>
		</div>
	</div>
	<br>
	<br>
	<br>

	<div
		class="row"
		*ngIf="!loading && objectives &&  objectives.length && resources && resources.length && activities">
		<div class="col-sm-12">
			<a
				class="fullscreen-pointer"
				(click)="toggleFullscreen()">

				<i
					ngbTooltip="fullscreen"
					class="fas fa-{{tablefull ? 'compress' : 'expand'}}-arrows-alt"></i>

			</a>

			<table class="table-matrix fullscreen-table">
				<thead>
					<tr>
						<th colspan="1"></th>
						<ng-template
							ngFor
							let-obj
							[ngForOf]="objectives">

							<th
								class="rotate"
								*ngFor="let a of obj.activities"
								colspan="2">

								<div>
									<span>{{a.name | truncate:35}}</span>
									<!-- tronca al numero di caratteri passati e aggiunge ... -->
								</div>
							</th>

						</ng-template>
					</tr>

					<tr>
						<th colspan="1"></th>
						<ng-template
							ngFor
							let-obj
							[ngForOf]="objectives">
							<ng-template [ngIf]="obj.activities && obj.activities.length">
								<th
									class="objective-label"
									[attr.colspan]="2 * obj.activities.length">
									{{obj.name}}
								</th>
							</ng-template>
						</ng-template>
					</tr>
					<tr>
						<th colspan="1"></th>
						<ng-template
							ngFor
							let-obj
							[ngForOf]="objectives">
							<ng-template [ngIf]="obj.activities && obj.activities.length">

								<ng-template
									ngFor
									let-a
									[ngForOf]="obj.activities">
									<th
										colspan="1"
										class="in-th">
										IN
									</th>
									<th
										colspan="1"
										class="out-th">
										OUT
									</th>

								</ng-template>

							</ng-template>

						</ng-template>

					</tr>

				</thead>

				<tbody>
					<tr *ngFor="let r of resources">

						<td
							class="names out-td"
							colspan="1">
							{{r.fullname}}
						</td>
						<ng-template
							ngFor
							let-obj
							[ngForOf]="objectives">
							<ng-template [ngIf]="obj.activities && obj.activities.length">

								<ng-template
									ngFor
									let-a
									[ngForOf]="obj.activities">
									<td
										colspan="1"
										class="in-td"
										[class.active]="inputValue['a'+ a.id +'r' + r.id + '-in']">
										<input
											type="number"
											class="small-input"
											[min]="0"
											(change)="toggle(a,r, 0)"
											[readonly]="project?.reporting"
											placeholder="0"
											[(ngModel)]="inputValue['a'+ a.id +'r' + r.id + '-in']">
									</td>
									<td
										colspan="1"
										class="out-td"
										[class.active]="inputValue['a'+ a.id +'r' + r.id + '-out']">
										<input
											type="number"
											[min]="0"
											class="small-input"
											[readonly]="project?.reporting"
											(change)="toggle(a,r, 1)"
											placeholder="0"
											[(ngModel)]="inputValue['a'+ a.id +'r' + r.id + '-out']">
									</td>

								</ng-template>

							</ng-template>

						</ng-template>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
